<mat-form-field appearance="outline">
  <mat-label *ngIf="easControl?.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
  <textarea matInput [placeholder]="'When your search term already contains a comma, enclose it in double quoutes before separating it, e.g. “David,Jones”,”John Smith”'" [value]="inputText"
    (input)="onTextChange($event.target.value)" (blur)="onBlur()" i18n-placeholder></textarea>
</mat-form-field>
